import { render, staticRenderFns } from "./user-details.html?vue&type=template&id=5e01d906&scoped=true&external"
import script from "./user-details.js?vue&type=script&lang=js&external"
export * from "./user-details.js?vue&type=script&lang=js&external"
import style0 from "./user-details.scss?vue&type=style&index=0&id=5e01d906&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e01d906",
  null
  
)

export default component.exports